export const SET_PAGE = 'set_page';
export const SET_PAGES_COUNT = 'set_pages_count';
export const SET_DATA = 'set_data';



// WEBPACK FOOTER //
// ./src/pagination/actions/types.js